module.exports = __webpack_public_path__ + "static/media/gradient_p.241b4eb7.mp4";